// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5551":"2cf41e8f","9594":"7deca895"}[chunkId] + ".chunk.css";
};